/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserStatisticsResponse } from './user-statistics-response';


export interface UserStatisticsResponsePagedList { 
    totalCount?: number;
    items?: Array<UserStatisticsResponse> | null;
}

